import {Injectable} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class RouteService {

  constructor(private router: Router) {
  }

  navigateToChartDynData(projectId: string | number, locationId: string, dateStart: string) {
    let startDate = moment(dateStart).utc(true).subtract(1, 'minutes').toISOString();
    let endDate = moment(dateStart).utc(true).add(1, 'minutes').toISOString();
    this.router.navigate(['/chart/' + projectId + '/' + locationId + '/' + startDate + '/' + endDate + '/dyn-data']).then(r => {
    });
  }

}
